@if (video()?.fullUrl && video()?.fullUrl !== 'app') {

@if (!isFullScreenMode()) {
<div disableRightClick
    class="relative group w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-gray-100 h-full">

    <button type="button" (click)="togglePlayPause(videoPlayer); $event.stopPropagation()"
        class="z-[1000] absolute top-1/2 right-[calc(50%-1rem)] rounded-full bg-transparent p-2 hover:bg-gray-200/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        @if (!isPlaying()) {
        <svg width="24" height="24" fill="#fff" class="size-8"
            stroke="#7c86ff" stroke-width="1" viewBox="-4 -3 24 24" aria-hidden="true">
            <path
                d='M13.82 9.523a.976.976 0 0 0-.324-1.363L3.574 2.128a1.031 1.031 0 0 0-.535-.149c-.56 0-1.013.443-1.013.99V15.03c0 .185.053.366.153.523.296.464.92.606 1.395.317l9.922-6.031c.131-.08.243-.189.325-.317zm.746 1.997l-9.921 6.031c-1.425.867-3.3.44-4.186-.951A2.918 2.918 0 0 1 0 15.03V2.97C0 1.329 1.36 0 3.04 0c.567 0 1.123.155 1.605.448l9.921 6.032c1.425.866 1.862 2.696.975 4.088-.246.386-.58.712-.975.952z' />
        </svg>
        }
        @else {
            <svg
            width="24"
            height="24"
            fill="#fff"
            class="size-8"
            stroke="#7c86ff"
            stroke-width="1"
            viewBox="0 0 24 24"
            aria-hidden="true">
            <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/>
        </svg>
        }
    </button>

    <div
        [class]="videoFormat === videoFormatEnum.Horizontal ? 'aspect-video' : videoFormat === videoFormatEnum.Square ? 'aspect-square' : 'aspect-9/16'"
        class="relative h-full w-full min-h-0 bg-gray-200 dark:bg-zinc-800">
        <!-- Placeholder/Loading State -->
        @if (isLoading() && !loadError()) {
        <div
            class="absolute inset-0 z-10 min-h-0 size-full overflow-hidden bg-gray-200 dark:bg-zinc-800 pointer-events-none"
            aria-busy="true"
            role="status">
            <span class="sr-only">Loading video</span>
            <div class="relative h-full w-full min-h-0" aria-hidden="true">
                <div
                    class="absolute inset-0 bg-linear-to-br from-gray-300 via-gray-200 to-gray-300 dark:from-zinc-600 dark:via-zinc-700 dark:to-zinc-600 animate-pulse motion-reduce:animate-none">
                </div>
                <div
                    class="absolute inset-[6%] rounded-md bg-gray-200/70 dark:bg-zinc-800/60 ring-1 ring-inset ring-gray-300/50 dark:ring-zinc-600/50 animate-pulse motion-reduce:animate-none [animation-delay:75ms]">
                </div>
                <div class="absolute bottom-[5%] left-[8%] right-[8%] flex items-center gap-2">
                    <div class="h-1 flex-1 rounded-full bg-gray-300 dark:bg-zinc-600 animate-pulse motion-reduce:animate-none"></div>
                    <div class="h-1 w-8 shrink-0 rounded-full bg-gray-300 dark:bg-zinc-600 animate-pulse motion-reduce:animate-none [animation-delay:100ms]"></div>
                </div>
            </div>
        </div>
        }

        <!-- Error State -->
        @if (loadError()) {
        <div class="absolute inset-0 z-[1001] flex items-center justify-center bg-gray-200 dark:bg-zinc-800">
            <div class="flex flex-col items-center gap-3 px-4 text-center">
                <div class="size-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6 text-red-600 dark:text-red-400">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                    </svg>
                </div>
                <div>
                    <h3 class="text-sm font-semibold text-primary">Video failed to load</h3>
                    <p class="text-xs text-secondary mt-1">{{ loadError() }}</p>
                </div>
                <button type="button" (click)="retryLoad(); $event.stopPropagation()"
                    class="rounded-md bg-white px-3 py-1.5 text-xs font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-zinc-700 dark:text-white dark:ring-zinc-600 dark:hover:bg-zinc-600">
                    Try again
                </button>
            </div>
        </div>
        }

        <!-- Video Element -->
        <video #videoPlayer [autoplay]="false" [id]="video()?.id" class="portrait h-full min-h-0 w-full object-contain"
            [class.opacity-0]="isLoading() || loadError()"
            [class.opacity-100]="!isLoading() && !loadError()"
            (click)="togglePlayPause(videoPlayer)" (play)="onPlay()" (pause)="onPause()"
            (loadedmetadata)="onLoadedMetadata(videoPlayer)" (canplay)="onCanPlay()"
            (error)="onVideoError(videoPlayer)" (timeupdate)="onTimeUpdate(videoPlayer)">
        </video>
    </div>

    @if (platformType() && platformType() === 'desktop') {




    <!-- Progress Bar -->
    <div class="progress-bar-container absolute bottom-2 left-2 right-2 h-1 bg-gray-200 rounded-lg cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        (click)="seek($event, videoPlayer)" (mousedown)="startScrubbing($event)" (touchstart)="startScrubbing($event)">

        <!-- Filled progress -->
        <div class="h-full bg-primary/55 rounded-lg relative" [style.width.%]="progress()"
            [style.opacity]="isScrubbing() ? 0 : 1">
            <!-- Thumb -->
            <div
                class="absolute -right-2 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-white border border-primary shadow-md cursor-grab active:cursor-grabbing z-10"
                [class.opacity-100]="isScrubbing()"
                [class.group-hover:opacity-100]="!isScrubbing()"
                [class.opacity-0]="!isScrubbing()"
                (mousedown)="startScrubbing($event); $event.stopPropagation()"
                (touchstart)="startScrubbing($event); $event.stopPropagation()">
            </div>

        </div>
    </div>

    <!-- Time -->
    <div
        class="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-xs text-white bg-[rgba(16,24,40,0.6)] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        {{ formatTime(currentTime()) }} / {{ formatTime(duration()) }}
    </div>

    } @else {

    <div class="absolute left-2 right-2 bottom-2 flex flex-row gap-x-2 justify-between items-center">


        <!-- Progress Bar -->
        <div class="progress-bar-container h-1 w-full bg-gray-200 rounded-lg cursor-pointer transition-opacity duration-200 opacity-0 group-hover:opacity-100"
            (click)="seek($event, videoPlayer)" (mousedown)="startScrubbing($event)"
            (touchstart)="startScrubbing($event)">

            <!-- Filled progress -->
            <div class="h-full bg-primary/55 rounded-lg relative" [style.width.%]="progress()"
                [style.opacity]="isScrubbing() ? 0 : 1">
                <!-- Thumb -->
                <div
                    class="absolute -right-2 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-white border border-primary shadow-md cursor-grab active:cursor-grabbing z-10"
                    [class.opacity-100]="isScrubbing()"
                    [class.group-hover:opacity-100]="!isScrubbing()"
                    [class.opacity-0]="!isScrubbing()"
                    (mousedown)="startScrubbing($event); $event.stopPropagation()"
                    (touchstart)="startScrubbing($event); $event.stopPropagation()">
                </div>

            </div>
        </div>

        <!-- Time -->
        <div
            class="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-xs text-white bg-[rgba(16,24,40,0.6)] px-2 py-1 rounded opacity-0 group-hover:opacity-100">
            {{ formatTime(currentTime()) }} / {{ formatTime(duration()) }}
        </div>

        <!-- Resize (Theater Mode) Button in Bottom Right -->
        <!-- <button type="button" (click)="openFullScreen(video); $event.stopPropagation()"
            class="w-6 h-6 transition-opacity duration-200">


            <ng-template #exitTheater>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-banana-icon lucide-banana"><path d="M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5"/><path d="M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z"/></svg>
            </ng-template>
        </button> -->
    </div>
    }

</div>
} @else {
<!-- <app-video-with-controls-full-screen [videoFormat]="videoFormat"/> -->
}
}
@else if (video()?.fullUrl === 'app') {
@if (showLargeError()) {
<div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-gray-200">
    <div class="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
        <div class="-mt-4 -ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
            <div class="mt-4 ml-4">
                <div class="flex items-center">
                    <div class="shrink-0">
                        <div class="size-12 rounded-full bg-yellow-100 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="size-8">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                            </svg>
                        </div>
                    </div>
                    <div class="ml-4">
                        <h3 class="text-base font-semibold text-gray-900">Whoops!</h3>
                        <p class="text-sm text-gray-500">
                            There was a problem when this video was uploaded.
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-4 ml-4 flex shrink-0 text-transparent">
                ...
            </div>
        </div>
    </div>

    <div class="px-4 py-20">
        <div class="text-center">
            <img class="mx-auto h-24 rounded-lg" src="../../../assets/images/unhappy-video.jpg" alt="">
            <h3 class="mt-2 text-sm font-semibold text-gray-900">There's been a problem...</h3>
            <p class="mt-1 text-sm text-gray-500">Please ask the creator to upload the video again.</p>
        </div>

    </div>
</div>
} @else {
<div class="text-center my-auto mt-6">
    <div class="mx-auto size-10 rounded-full bg-yellow-100 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
    </div>
    <h3 class="mt-2 text-sm font-semibold text-gray-900">Whoops!</h3>
</div>
}

} @else {
<div class="flex flex-col items-center justify-center w-full rounded-lg bg-zinc-100 dark:bg-zinc-800/60 aspect-video text-center px-6">
  <div class="flex items-center justify-center size-14 rounded-2xl bg-rose-100 dark:bg-rose-900/20 mb-4">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-7 text-rose-500 dark:text-rose-400">
      <path stroke-linecap="round" stroke-linejoin="round"
          d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"/>
    </svg>
  </div>
  <h3 class="text-sm font-semibold text-primary">Video unavailable</h3>
  <p class="mt-1 text-xs text-secondary max-w-[200px]">This video could not be loaded. It may still be processing or have been removed.</p>
</div>
}